module.exports = __webpack_public_path__ + "c604d19f158554a9b1b36b51ae30412b.png";